module.exports = __webpack_public_path__ + "img/logo-cssa.07dfafaa.jpg";